import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { ICRMUser } from '@care-portals/api-interfaces';

@Injectable({
  providedIn: 'root'
})
export class DosespotService {
  private notificationsSubject = new BehaviorSubject<number>(0);
  notifications$ = this.notificationsSubject.asObservable();

  private ssoUrlSubject = new BehaviorSubject<string>('');
  ssoUrl$ = this.ssoUrlSubject.asObservable();

  private dosespotClinicianIdSubject = new BehaviorSubject<string>('');
  dosespotClinicianId$ = this.dosespotClinicianIdSubject.asObservable();

  private dosespotClinicIdSubject = new BehaviorSubject<string>('');
  dosespotClinicId$ = this.dosespotClinicIdSubject.asObservable();

  private isConfiguredSubject = new BehaviorSubject<boolean>(false);
  isConfigured$ = this.isConfiguredSubject.asObservable();

  constructor() {
    combineLatest([
      this.ssoUrl$,
      this.dosespotClinicId$,
      this.dosespotClinicianId$
    ]).subscribe(([ssoUrl, clinicId, clinicianId]) => {
      console.log('ssoUrl', ssoUrl);
      console.log('clinicId', clinicId);
      console.log('clinicianId', clinicianId);
      console.log('isConfigured', Boolean(ssoUrl && clinicId && clinicianId));
      this.isConfiguredSubject.next(Boolean(ssoUrl && clinicId && clinicianId));
    });
  }

  updateNotificationCount(user: ICRMUser) {
    const {
      PendingPrescriptionCount = 0,
      TransmissionErrorCount = 0,
      RefillRequestCount = 0,
      ChangeRequestCount = 0
    } = user?.extras?.dosespotNotificationCounts || {};

    const total =
      PendingPrescriptionCount +
      TransmissionErrorCount +
      RefillRequestCount +
      ChangeRequestCount;

    this.notificationsSubject.next(total as number);
  }

  updateSsoUrl(url: string) {
    this.ssoUrlSubject.next(url);
  }

  updateClinicianId(clinicianId: string) {
    this.dosespotClinicianIdSubject.next(clinicianId);
  }

  updateClinicId(clinicId: string) {
    this.dosespotClinicIdSubject.next(clinicId);
  }

  openDosespot({
    patientId,
    orderId
  }: {
    patientId?: string;
    orderId?: string;
  }) {
    let url = this.ssoUrlSubject.value;

    if (patientId) {
      url += `&PatientID=${patientId}`;
    }
    if (orderId) {
      url += `&EncounterID=${orderId}`;
    }

    console.log('dosespot SSO url >>>> ', url);

    if (url) {
      window.open(url, '_blank');
    }
  }
}
